var map = {
	"./active-item.png": "b7ac",
	"./base-musicbox.png": "e4b3",
	"./bg.png": "d68e",
	"./changedisc.png": "8f84",
	"./close.png": "cd5c",
	"./fz.png": "617c",
	"./handler-bg.png": "ce30",
	"./img/audition/bg.png": "33c5",
	"./img/audition/bg1.png": "4d03",
	"./img/audition/listen.png": "34fd",
	"./img/bg.png": "dc97",
	"./img/draw/box.png": "3fec",
	"./img/draw/btn.png": "8137",
	"./img/draw/pause.png": "6795",
	"./img/draw/play.png": "6cb5",
	"./img/draw/text.png": "60f4",
	"./img/draw/title.png": "9a16",
	"./img/home/bg.png": "2de1",
	"./img/music-icon.png": "56f1",
	"./img/phonograph/bg-box01.png": "b3b9",
	"./img/phonograph/bg-box02.png": "073c",
	"./img/phonograph/btn01.png": "14e5",
	"./img/phonograph/btn1.png": "e03c",
	"./img/phonograph/card01.png": "2671",
	"./img/phonograph/cd01.png": "82df",
	"./img/phonograph/cd02-mask.png": "985c",
	"./img/phonograph/cd02.png": "ff1d",
	"./img/phonograph/gen-poster.png": "c88f",
	"./img/phonograph/text01.png": "68d9",
	"./img/share-bg.png": "9082",
	"./img/share.png": "cff1",
	"./img/sprites.png": "c618",
	"./m-icon.png": "99ee",
	"./m-item1.png": "a463",
	"./m-item2.png": "a0c8",
	"./m-item3.png": "8811",
	"./m-item4.png": "0f29",
	"./musicbox-arm.png": "f085",
	"./musicbox-slot.png": "6014",
	"./musicbox.png": "d3b1",
	"./nc-bg.png": "c2f2",
	"./noactive-item.png": "5194",
	"./open-act-btn.png": "e7cc",
	"./open-more.png": "c3e0",
	"./scroll-bg1.png": "be6d",
	"./scroll-bg2.png": "630b",
	"./scroll-bg3.png": "9f1a",
	"./scroll-bg4.png": "0652",
	"./sd.png": "5e65",
	"./sg.png": "e2fc",
	"./share-qq.png": "8af3",
	"./share-qzone.png": "6c5e",
	"./share-wechat-hy.png": "f213",
	"./share-wechat-pyq.png": "8091",
	"./share-weibo.png": "63f1",
	"./to-draw-page.png": "81e1",
	"./to-draw.png": "67ea",
	"./tonext.png": "b22f",
	"./topaused.png": "5877",
	"./toplay.png": "4323",
	"./topre.png": "d2bf",
	"./touch.png": "10f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1083";